import RoleManagementRoles from './RoleManagementRoles.vue';

export default RoleManagementRoles;
